import '../static/Heading.css';
import React__default, { forwardRef } from "react";
import clsx from "clsx";
import { a as RichText } from "./RichText.Dek7-xX-.mjs";
const heading = `_heading_25030b4`;
const sizemd = `_sizemd_0ca33d2`;
const sizelg = `_sizelg_8fc2be9`;
const sizexl = `_sizexl_a624c37`;
const size2xl = `_size2xl_2eaf43f`;
const size3xl = `_size3xl_ae991ff`;
const size4xl = `_size4xl_a7f01cb`;
const size5xl = `_size5xl_3b91220`;
const gradient = `_gradient_7d17d90`;
const gradientRichText = `_gradientRichText_f54278f`;
const light = `_light_b361b31`;
const styles = { heading, sizemd, sizelg, sizexl, size2xl, size3xl, size4xl, size5xl, gradient, gradientRichText, light };
const HEADING_SIZE = [
  "5xl",
  "4xl",
  "3xl",
  "2xl",
  "xl",
  "lg",
  "md"
];
const HEADING_VARIANT = ["default", "gradient"];
const HEADING_WEIGHT = ["bold", "light"];
const Heading = forwardRef(
  ({
    as,
    children,
    className,
    size = "3xl",
    variant = "default",
    weight = "bold",
    ...props
  }, ref) => {
    return /* @__PURE__ */ React__default.createElement(
      RichText,
      {
        as: as || "h2",
        allowedTags: ["b", "strong"],
        gradientBoldText: true,
        className: clsx(
          styles.heading,
          styles[`size${size}`],
          styles[variant],
          styles[weight],
          className
        ),
        ref,
        "data-ui-heading": true,
        ...props
      },
      children
    );
  }
);
export {
  HEADING_SIZE as H,
  HEADING_VARIANT as a,
  HEADING_WEIGHT as b,
  Heading as c
};
//# sourceMappingURL=Heading.D9qZoTZe.mjs.map
